import { Paper, Stack } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { ResearchCenter } from './../../model/ResearchCenterTypes';
import classes from './ResearchCenterCard.module.css';

export interface ResearchCenterCardProps {
  researchCenter: ResearchCenter;
  to: string;
}

export function ResearchCenterCard({ researchCenter, to }: ResearchCenterCardProps) {
  const { name } = researchCenter;

  return (
    <Paper
      className={classes.card}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="10px">
        <TitleCard title={name} />
      </Stack>
    </Paper>
  );
}
